import React from "react";

import { useTranslation } from "utils";

import { PracticeBundle } from "models";

import { Button, Flex, Icon, Tooltip, Typography } from "components";

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * TODO (Alp): Remove this after Soil+ 3.0 is done
 */
export const PracticeEnrolmentNudgeCard = ({
  practiceBundleSlug,
  onClick,
  disabled,
}: {
  practiceBundleSlug: PracticeBundle["slug"];
  onClick: React.MouseEventHandler;
  disabled: boolean;
}) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Flex
      align="center"
      className="practice-enrolment-nudge-card"
      data-testid={`practice-enrolment-nudge-card-${practiceBundleSlug === "tillages" ? "tillage" : "fertilizer"}`}
      gap={24}
    >
      <Icon iconName={`klim/${practiceBundleSlug}`} size="xl" />
      <div>
        <Typography variant="h5">
          {t(`cropAddEditDrawer.practiceEnrolmentNudgeCard.title.${practiceBundleSlug === "tillages" ? "tillage" : "fertilizer"}`)}
        </Typography>
        <Typography variant="paragraph-m">
          {t(`cropAddEditDrawer.practiceEnrolmentNudgeCard.description.${practiceBundleSlug === "tillages" ? "tillage" : "fertilizer"}`)}
        </Typography>
      </div>
      <Tooltip title={disabled ? t("cropAddEditDrawer.practiceEnrolmentNudgeCard.disabled") : null}>
        <Button className="practice-enrolment-nudge-button" type="primary" onClick={onClick} disabled={disabled}>
          <Typography variant="paragraph-m">{t("cropAddEditDrawer.practiceEnrolmentNudgeCard.activate")}</Typography>
        </Button>
      </Tooltip>
    </Flex>
  );
};
